import * as React from 'react';
import { observer } from 'mobx-react-lite';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import PersonaIcon from 'owa-calendar-forms-common/lib/components/PersonaIcon';
import OrganizerData from 'owa-calendar-forms-common/lib/components/OrganizerData';

const styles = require('./CalendarItemPeek.scss');

export interface OrganizerDataRowProps {
    organizer: EmailAddressWrapper;
    isOrganizer: boolean;
    invitee: EmailAddressWrapper;
}

const OrganizerDataRow: React.FunctionComponent<OrganizerDataRowProps> = observer(props => {
    const { organizer, isOrganizer, invitee } = props;

    return (
        <div className={styles.dataRow}>
            <div className={styles.organizerPersonaContainer}>
                <PersonaIcon name={organizer.Name} emailAddress={organizer.EmailAddress} />
            </div>
            <div className={styles.dataRowValue}>
                <div>
                    <OrganizerData
                        organizer={organizer}
                        isOrganizer={isOrganizer}
                        invitee={invitee}
                    />
                </div>
            </div>
        </div>
    );
});

export default OrganizerDataRow;
